// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2jrSI","header":"ClearentDisclaimer_header__2oPpc","inner":"ClearentDisclaimer_inner__vtVJ1"};